import { Button } from '@southfields-digital/mpxlive-components';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Tooltip } from 'src/components/Tooltip';
import { StateType } from 'src/redux/reducers';
import {
  REQUEST_DELETE_PLAYLIST,
  REQUEST_DUPLICATE_PLAYLIST,
} from 'src/redux/reducers/playlist';

import type { PlaylistActionBarProps } from './PlaylistActionBar';

export default function DefaultActionBar({
  playlistId,
  editable,
  onToggleEditable,
  onAddGraphic,
  onEdit,
}: PlaylistActionBarProps) {
  const dispatch = useDispatch();

  const rundownId = useSelector((state: StateType) => state.rundown.detail.data?.id);

  const handleDuplicate = useCallback(() => {
    if (!playlistId || !rundownId) return;
    dispatch({
      type: REQUEST_DUPLICATE_PLAYLIST,
      payload: { id: playlistId, rundownId },
    });
  }, [dispatch, playlistId, rundownId]);

  const handleDelete = useCallback(() => {
    if (!playlistId) return;
    dispatch({
      type: REQUEST_DELETE_PLAYLIST,
      payload: { id: playlistId },
    });
  }, [dispatch, playlistId]);

  const handleToggleEditable = useCallback(() => {
    onToggleEditable?.(!editable);
  }, [onToggleEditable, editable]);

  return (
    <div className="flex gap-1.5 w-full h-fit py-1.5 px-3 items-center">
      <Tooltip overlay={editable ? 'Lock playlist' : 'Unlock playlist'}>
        <Button
          iconProps={{ icon: editable ? 'lock-key-open' : 'lock-key', ...(!editable && { color: '#4155ff' }) }}
          variant="muted"
          buttonSize="small"
          onClick={handleToggleEditable}
        />
      </Tooltip>

      <div className="flex gap-1 ml-auto">
        <Tooltip overlay="Add graphic">
          <Button
            iconProps={{ icon: 'plus' }}
            variant="muted"
            buttonSize="small"
            disabled={!editable}
            onClick={onAddGraphic}
          />
        </Tooltip>
        <Tooltip overlay="Rename playlist">
          <Button
            iconProps={{ icon: 'pencil' }}
            variant="muted"
            buttonSize="small"
            disabled={!editable || !playlistId}
            onClick={onEdit}
          />
        </Tooltip>
        <Tooltip overlay="Duplicate playlist">
          <Button
            iconProps={{ icon: 'copy' }}
            variant="muted"
            buttonSize="small"
            disabled={!editable || !playlistId}
            onClick={handleDuplicate}
          />
        </Tooltip>
        <Tooltip overlay="Delete playlist">
          <Button
            iconProps={{ icon: 'trash' }}
            variant="muted"
            buttonSize="small"
            disabled={!editable || !playlistId}
            onClick={handleDelete}
          />
        </Tooltip>
      </div>
    </div>
  );
}
